import React, { Component, Fragment } from 'react';
import CustomAlert from '../components/CustomAlert/CustomAlert';
import StickyBlock from './StickyBlock';

const initialState = {
  show: false,
  alertType: '',
  message: '',
  dismissable: true,
  closeInSeconds: null,
  redirectPath: '',
};

const WithAlert = (WrappedComponent) => {
  return class extends Component {
    state = {
      ...initialState,
    };

    showAlert = (params) => {
      this.setState((prevState) => ({
        show: true,
        ...params,
      }));
    };

    closeAlert = () => {
      this.setState(() => ({
        ...initialState,
      }));
    };

    render() {
      const { show, dismissable } = this.state;

      return (
        <>
          {show && (
            <StickyBlock dismissable={dismissable}>
              <div className="alert-notifications-wrapper">
                <CustomAlert params={this.state} onClose={this.closeAlert} />
              </div>
            </StickyBlock>
          )}
          <WrappedComponent
            {...this.props}
            showAlert={this.showAlert}
            closeAlert={this.closeAlert}
          />
        </>
      );
    }
  };
};

export default WithAlert;
